import React from 'react';
import { X, Trash2, AlertTriangle } from 'lucide-react';
import type { TicketWithUser } from '../../../services/ticketService';

type AdminTicketDeleteModalProps = {
  ticket: TicketWithUser;
  onClose: () => void;
  onConfirm: () => void;
  deleting: boolean;
};

const AdminTicketDeleteModal: React.FC<AdminTicketDeleteModalProps> = ({
  onClose,
  onConfirm,
  deleting,
}) => (
  <div className="admin-ticket-delete-modal-overlay">
    <div className="admin-ticket-delete-modal">
      <div className="admin-ticket-delete-modal-header">
        <div className="admin-ticket-delete-modal-icon-wrap">
          <AlertTriangle className="w-6 h-6 text-red-400" />
        </div>
        <div className="admin-ticket-delete-modal-content">
          <h3 className="admin-ticket-delete-modal-title">Confirm Deletion</h3>
          <p className="admin-ticket-delete-modal-text">
            Are you sure you want to delete this ticket? This action cannot be undone.
          </p>
        </div>
        <button type="button" onClick={onClose} className="admin-ticket-delete-modal-close" aria-label="Close">
          <X className="w-5 h-5" />
        </button>
      </div>
      <div className="admin-ticket-delete-modal-actions">
        <button type="button" onClick={onClose} className="admin-ticket-delete-modal-cancel">
          Cancel
        </button>
        <button
          type="button"
          onClick={onConfirm}
          disabled={deleting}
          className="admin-ticket-delete-modal-confirm"
        >
          {deleting ? (
            <>
              <span className="admin-ticket-delete-modal-spinner" />
              <span>Deleting...</span>
            </>
          ) : (
            <>
              <Trash2 className="w-4 h-4" />
              <span>Delete</span>
            </>
          )}
        </button>
      </div>
    </div>
  </div>
);

export default AdminTicketDeleteModal;
